import React from 'react';
import ShoppingItem from './ShoppingItem';
import CheckOutItem from './CheckOutItem';
import CheckOutCart from "./CheckOutCart";
import {useMedia} from "react-use";
import Carousel, { consts } from "react-elastic-carousel";
import BtnOrder from "../button/BtnOrder";
import {TweenLite} from "gsap";

const OrderSummary = (props) => {

    const isMobile = useMedia("(max-width: 992px)");
    const isTablet = useMedia("(min-width: 768px) and (max-width: 991px)");

    const deviceList = [props.data.extras.modem, props.data.extras.extender];
    let selectedDevice = [];

    props.selectedExtras.forEach((key) => {
        selectedDevice.push(key);
    })

    const checkForDevicesName = (title) => {
        if (title.toLowerCase().includes('modem')) {
            return 'modem';
        } else if (title.toLowerCase().includes('extender')) {
            return 'extender';
        }
        return  '';
    }

    const devices = deviceList.map((item, key) => {
        return (
            <ShoppingItem
                key={key}
                features={props.data.extras.modem.list}
                item={item}
                price={item.priceLarge + " / Upfront"}
                active={ selectedDevice.includes( checkForDevicesName(item.title)) ? "card-active": ""}
                handleRemoveFromCart={() => props.handleRemoveFromCart( checkForDevicesName(item.title))}
                handleAddToCart={() => props.handleAddToCart( checkForDevicesName(item.title))}
            />
        );
    });

    const mobile = (
        <Carousel
            children={devices}
            itemsToShow={1}
            showArrows={false}
            outerSpacing={0}
            pagination={true}
        />
    );

    const tablet = (
        <div className="d-flex space-around flex-row">
            {devices}
        </div>
    );

    const desktop = (
        <div>
            {
                deviceList.map((item, key) => {
                    const deviceName = checkForDevicesName(item.title);
                    return (
                        <ShoppingItem
                            key={key}
                            class={"mb-40"}
                            features={props.data.extras.modem.list}
                            item={item}
                            price={item.upfrontPrice > 0 ? `${item.priceLarge} / Upfront` : item.priceLarge}
                            active={ selectedDevice.includes(deviceName) ? "card-active": ""}
                            handleRemoveFromCart={() => props.handleRemoveFromCart(deviceName)}
                            handleAddToCart={() => props.handleAddToCart(deviceName)}
                        />)
                })
            }
        </div>
    );

    const checkForPromotion = (plan) => {
        if (plan.special && plan.special.planPrice && plan.special.duration) {
            return 'for first '+ plan.special.duration + ' then ' + "$" + props.calcMonthlyPrice(plan) + '/mth ongoing';
        }
    }

    const scrollTo = (event) => {
        event.preventDefault();
        TweenLite.to(window, 0.5, {scrollTo: {y: document.getElementById('sq-field-trigger'), offsetY: 240}});
    };

    return (
        <article className="order-summary pb-5">
            <div className="order-summary-container">
                <div className="row">
                    <div className="col-12 col-lg-4">
                        <div className={`pb-5 ${!isMobile ? "mb-3": ""}`}>
                            <h2 className="color-white">Plug in and get down to business.</h2>
                            <p className="color-white">
                                Preconfigured for easy setup, our modems and extenders deliver the speed and reliability your business needs, while full remote support gives you peace of mind.
                            </p>
                        </div>
                        {
                            isMobile ? !isTablet ? mobile : tablet : desktop
                        }
                    </div>
                    <div className={`col-12 col-lg-7 ${isMobile ? "mt-5 pt-3": ""}`}>
                        <h1 className="color-white">Voilà 🎉 Here’s what you’ve ordered…   </h1>
                        <h3 className="medium-bold color-lime font-medium-x-large">Plan details</h3>
                        <CheckOutItem
                            borderRadius={"upperBorderRadius"}
                            background={"white"} title={"Your Flip to Fibre™ plan:"}
                            plan={props.selectedPlan.planHeading + ` nbn™ ${props.selectedPlan.planDownloadSpeed}/${props.selectedPlan.planUploadSpeed}`}
                            fontColor={"color-black"}
                            price={"$" + props.calcMonthlyPrice(props.selectedPlan) + "/mth"}
                            promotion={() => checkForPromotion(props.selectedPlan)}
                        />
                        <CheckOutItem
                            borderRadius={"noBorderRadius"}
                            background={"white"} title={"Your interim plan: "} fontColor={"color-black"}
                            plan={props.selectedInterimPlan.planHeading + ` nbn™ ${props.selectedInterimPlan.planDownloadSpeed}/${props.selectedInterimPlan.planUploadSpeed}`}
                            price={"$" + props.selectedInterimPlan.price + "/mth"}
                            promotion={"This is your plan before business fibre activates. "}
                        />
                        <CheckOutItem
                            borderRadius={"lowerBorderRadius"}
                            background={"cadet"} fontColor={"color-white"} color={"white"}
                            title={"Total monthly cost"}
                            price={"$" + props.calcMonthlyPrice(props.selectedPlan) + "/mth"}
                            promotion={() => checkForPromotion(props.selectedPlan)}
                        />
                        <br/>
                        <h3 className="medium-bold color-lime font-medium-x-large">Upfront cost</h3>
                        {
                            props.selectedExtras.map((key) => {
                               return (
                                   <CheckOutCart
                                        key={key}
                                        background={"white"}
                                        borderRadius={"borderRadius"}
                                        title={"WiFi " + key}
                                        device={props.data.extras[key].title}
                                        price={props.data.extras[key].priceLarge}
                                        promotion={"$20 delivery fee"}
                                        showQuantity={ key === "extender" }
                                        updateCart={props.updateCart}
                                        quantity={props.quantity}
                                        upFrontPrice={props.data.extras[key].upfrontPrice}
                                   />
                               )
                            })
                        }
                        <div className="row p-0">
                            <p className="col-md-8 colour-Gray91 mt-5 col-sm-8">Total upfront cost ${props.upfrontTotal} & Total min cost ${props.minCharge} plus any pro-rata charges for 30-day cancellation notice period.</p>
                            <BtnOrder text={`${props.isAbleToF2F ? 'Order now': 'Check address'}`} class={"col-md-4 mt-4 bold col-sm-4 p-2"} onClick={!props.isAbleToF2F ? scrollTo: props.handleSubmit} />
                        </div>
                    </div>
                </div>
               <div>
             </div>
            </div>
        </article>
    );
}

export default OrderSummary;


// WEBPACK FOOTER //
// ./resources/assets/js/flipToFibre/orderSummary/OrderSummary.js